import { APP_TYPES } from '@constants/individualPortal/dashboard/dashboardModelTypes';
import { addToDate, formatDate, getYearInNumber, setDate } from '../dates/date.utils';

export const getNextMonthFistDay = (currentDate, format = '') => {
    return formatDate(setDate({ date: 1 }, addToDate(1, 'month', currentDate)), format);
};

export const getNextYearFirstDay = (currentDate, format = '') => {
    return formatDate(setDate({ date: 1, month: 0 }, addToDate(1, 'years', currentDate)), format);
};

export const resolveStartingDate = (serverDate, coverageYear, applicationType) => {

    const isOepApplication = applicationType === APP_TYPES.OE;

    switch(true) {
        case isOepApplication:
            switch(true) {
                case coverageYear !== getYearInNumber(serverDate):
                    return getNextYearFirstDay(serverDate);
                default:
                    return getNextMonthFistDay(serverDate);
            }
        default:
            return getNextMonthFistDay(serverDate);
    }
};